"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  form: {
    "& .mco-form-input": {
      flex: "0 0 100% !important"
    }
  },
  button: {
    display: "flex",
    flex: "0 0 100%",
    gap: theme.spacing(1),
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
    "& .mco-form-button-wrapper": {
      flex: "none"
    }
  }
}));
var _default = exports.default = styles;